import { CommonSelectorElement } from "../interfaces/types.selector";

export default class CommonSelector implements CommonSelectorElement {
    id: number;
    elementName: string;

    constructor(key: number, name: string) {
        this.id = key
        this.elementName = name;
    }
}

export interface PaginationProps {
    count: number;
    offset: number;
    recalculate: boolean;
    sortMode: number,
    sortCategory: any,
    OrderingEntityIds?: number[];
    report: boolean;
    total_count: number;
    report_index: number;
    OrderByPinned?: boolean;
    forceInitial?: boolean;
    /** принудительно слать запрос на /Ordered, даже если нет сортировки и OrderByPinned=false
        (например, при сбросе сортировки по закреплённым нужно явно отправить OrderByPinned=false) */
    forceOrdered?: boolean;
}